export const DEFAULT_SELF_HOSTED_SERVER_NAME = 'Goldllen';

export function getSelfHostedServerName(serverName?: string | null) {
  const isDefaultName =
    !serverName ||
    [
      'AFFiNE',
      'AFFiNE Cloud',
      'AFFiNE Self-hosted',
      DEFAULT_SELF_HOSTED_SERVER_NAME,
    ].includes(serverName);
  return !isDefaultName
    ? `${DEFAULT_SELF_HOSTED_SERVER_NAME} (${serverName})`
    : DEFAULT_SELF_HOSTED_SERVER_NAME;
}
